import VRMessageController from "./VRMessage-controller"
import VRInformationController from "./VRInformation-controller"

const VRMessageControllers = new VRMessageController();
const VRInformationControllers = new VRInformationController();

export {
    VRMessageControllers,
    VRInformationControllers
};